import request from '@/shared/api/request';

export const saveKubernetesTags = (uuid: string, data: { tags: string[] }): Promise<unknown> =>
  request({
    url: `/kubernetes/${uuid}/tags/`,
    method: 'PUT',
    data,
  });
